// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__rGW3Q","tag":"style_tag__Lj76V"};